/* unplugin-vue-components disabled */import { render } from "./Index.vue?vue&type=template&id=98c76482&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=98c76482&scoped=true&lang=scss"
import "./Index.vue?vue&type=style&index=1&id=98c76482&lang=scss"

import exportComponent from "/Users/shinone/workingspace/xw/xwtec-assets-client/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.24_vue@3.5.24_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98c76482"]])

export default __exports__